import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ParsedEmail } from '../models/parsedemail.model';
import { Order } from '../models/order.model';
import { UrlService } from './url.service';

@Injectable({
  providedIn: 'root'
})
export class ParsedemailService {

	private svcUrl = '/ParsedEmails';

	constructor(private http: HttpClient, private url: UrlService) { }

	getParsedEmail(id: number): Observable<ParsedEmail> {
		return this.http.get<ParsedEmail>(this.url.getBaseURL() + this.svcUrl + '/' + id);
	}

	getParsedEmailsForBrokerId(id: number, isDismissed?: boolean | null, itemStart?: number | null, itemCount?: number | null) {
		let params = new HttpParams()
			.set('IsDismissed', (isDismissed == null ? false : isDismissed))
			.set('ItemStart', (itemStart == null ? 0 : itemStart))
			.set('ItemCount', (itemCount == null ? 100 : itemCount));
		return this.http.get<ParsedEmail[]>(this.url.getBaseURL() + this.svcUrl + '/Broker/' + id, { params });
	}

	getParsedEmailsForUserId(id: string, isDismissed?: boolean | null, itemStart?: number | null, itemCount?: number | null) {
		let params = new HttpParams()
			.set('IsDismissed', (isDismissed == null ? false : isDismissed))
			.set('ItemStart', (itemStart == null ? 0 : itemStart))
			.set('ItemCount', (itemCount == null ? 100 : itemCount));
		return this.http.get<ParsedEmail[]>(this.url.getBaseURL() + this.svcUrl + '/User/' + id, { params });
	}

	getParsedEmailsForEmailRequestId(id: number, isDismissed?: boolean | null) {
		let params = new HttpParams()
			.set('IsDismissed', (isDismissed == null ? false : isDismissed));
		return this.http.get<ParsedEmail[]>(this.url.getBaseURL() + this.svcUrl + '/EmailRequest/' + id, { params });
	}

	createParsedEmail(id: number): Observable<ParsedEmail> {
		// here, the id is the EmailRequest Id
		return this.http.post<ParsedEmail>(this.url.getBaseURL() + this.svcUrl + '/CreateParsedEmail/' + id, '{}');
	}

	submitParsedEmailToAI(id: number): Observable<ParsedEmail> {
		// here, the id is the ParsedEmail Id
		return this.http.post<ParsedEmail>(this.url.getBaseURL() + this.svcUrl + '/SubmitParsedEmailToAI/' + id, '{}');
	}

	dismissParsedEmail(id: number): Observable<ParsedEmail> {
		return this.http.post<ParsedEmail>(this.url.getBaseURL() + this.svcUrl + '/Dismiss/' + id, {});
	}

	createDerivedParsedEmail(parentParsedId: number, order: Order | null | undefined) {
		return this.http.post<ParsedEmail>(this.url.getBaseURL() + this.svcUrl + '/CreateDerivedParsedEmail/' + parentParsedId, order);
	}

}
